import { ComponentType as g } from "../../registries/types/propTypes.js";
const C = (e) => {
  var c, n, l, i, p, m, s, y, u, _, T, f;
  let r = {};
  return e && (r = {
    type: e == null ? void 0 : e.content_type,
    resourceType: e == null ? void 0 : e.file_type,
    imageList: (n = (c = e == null ? void 0 : e.banner) == null ? void 0 : c.images) == null ? void 0 : n.map((o) => ({
      url: o.image.url,
      altText: o.alt_text,
      viewport: o.viewport
    })),
    tag: e == null ? void 0 : e.tag,
    title: e == null ? void 0 : e.display_title,
    description: e == null ? void 0 : e.description,
    time: e == null ? void 0 : e.time,
    date: e == null ? void 0 : e.date,
    backgroundColor: (l = e == null ? void 0 : e.background) == null ? void 0 : l.color,
    color: (i = e == null ? void 0 : e.color) == null ? void 0 : i.color,
    themeColor: (m = (p = e == null ? void 0 : e.theme_color) == null ? void 0 : p.color) == null ? void 0 : m.color,
    themeShade: (y = (s = e == null ? void 0 : e.theme_color) == null ? void 0 : s.theme) == null ? void 0 : y.theme,
    size: e == null ? void 0 : e.size,
    startDate: e == null ? void 0 : e.start_date,
    firstAccountTypeTitle: (u = e == null ? void 0 : e.primary_account_type) == null ? void 0 : u.label,
    secondAccountTypeTitle: (_ = e == null ? void 0 : e.secondary_account_type) == null ? void 0 : _.label,
    firstAccountTypeDate: (T = e == null ? void 0 : e.primary_account_type) == null ? void 0 : T.date,
    secondAccountTypeDate: (f = e == null ? void 0 : e.secondary_account_type) == null ? void 0 : f.date,
    url: e == null ? void 0 : e.url
  }), {
    componentType: g.content_card,
    ...r
  };
};
export {
  C as default
};
//# sourceMappingURL=content-card-transformer.js.map
